import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from '../Home/Home';
import Solutions from '../Solutions/Solutions';
import Projects from '../Projects/Project';
import ProjectDetail from '../Projects/ProjectDetail';
import News from '../News/News';
import About from '../About/About';
import Contact from '../Contact/Contact';
import SearchResults from '../SearchPage/SearchPage';
import '../styles/page-transition.css';

const setTitle = (pageName) =>
  pageName ? `${pageName} | Vientiane Traffic` : 'Vientiane Traffic';

const routes = [
  { path: '/', meta: { title: setTitle('Home') }, element: <Home /> },
  { path: '/solutions', meta: { title: setTitle('Solutions') }, element: <Solutions /> },
  { path: '/projects', meta: { title: setTitle('Projects') }, element: <Projects /> },
  {
    path: '/project-detail/:projectId',
    meta: { title: setTitle('Project Detail') },
    element: <ProjectDetail />,
  },
  { path: '/news', meta: { title: setTitle('News') }, element: <News /> },
  { path: '/about', meta: { title: setTitle('About Us') }, element: <About /> },
  { path: '/contact', meta: { title: setTitle('Contact') }, element: <Contact /> },
  { path: '/search', meta: { title: setTitle('Search') }, element: <SearchResults /> },
];

const legacyRedirects = [
  { from: '/Solutions', to: '/solutions' },
  { from: '/Projects', to: '/projects' },
  { from: '/News', to: '/news' },
  { from: '/About', to: '/about' },
  { from: '/Contact', to: '/contact' },
];

const RouteWithMeta = ({ route }) => {
  const location = useLocation();

  React.useEffect(() => {
    if (route.meta?.title) {
      document.title = route.meta.title;
    }
  }, [location, route.meta?.title]);

  return route.element;
};

const AppRouter = () => {
  const location = useLocation();

  return (
    <div key={location.pathname} className="vt-page-enter">
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RouteWithMeta route={route} />}
          />
        ))}
        {legacyRedirects.map(({ from, to }) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}
      </Routes>
    </div>
  );
};

export default AppRouter;
